import { authGuard } from '@auth0/auth0-vue';
import { RouteNames } from '@/data/routes';
import { createRoutes } from '@/utils/router-helper';

import VerifyingPage from '@/pages/verification/VerifyingPage.vue';
import CompletePage from '@/pages/verification/CompletePage.vue';
import InfoPage from '@/pages/verification/InfoPage.vue';
import DocumentsPage from '@/pages/verification/DocumentsPage.vue';

export default createRoutes({
  path: 'verification',
  beforeEnter: authGuard,
  meta: {
    hasAccess: ({ store }) => !!store?.getters.isLexisNexisDDPEnabled,
    fallbackRoute: RouteNames.OWNERS.INDEX,
  },
  children: [
    {
      path: 'verifying',
      name: RouteNames.VERIFICATION.VERIFYING,
      component: VerifyingPage,
    },
    {
      path: 'complete',
      name: RouteNames.VERIFICATION.COMPLETE,
      component: CompletePage,
    },
    {
      path: 'info',
      name: RouteNames.VERIFICATION.INFO,
      component: InfoPage,
    },
    {
      path: 'documents',
      name: RouteNames.VERIFICATION.DOCUMENTS,
      component: DocumentsPage,
    },
  ],
});
